import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useTracking, twMerge } from '@belong/common';
import css from './ButtonBase.module.css.js';

const ButtonBase = /*#__PURE__*/React.forwardRef(function ButtonBase({
  id,
  name,
  className,
  onSelect,
  onClick,
  trackingData = {},
  children,
  ...rest
}, ref) {
  const track = useTracking();
  function handleClick(event) {
    const _trackingData = {
      ...trackingData
    };
    if (event?.target) {
      // @ts-ignore
      _trackingData.text = event.target.innerText;
    }
    _trackingData.component = 'button';
    if (rest.role === 'tab') {
      _trackingData.component = 'tab';
    }
    track('click', {
      name: id || name,
      ..._trackingData
    });
    // MenuItem receives onSelect even when you pass a button, but works in the same way.
    if (onSelect) return onSelect(event);
    if (onClick) return onClick(event);
    return;
  }
  return jsx("button", {
    id: id,
    className: twMerge('p-0 border-none outline-none enabled:cursor-pointer bg-transparent', css.buttonBase, className),
    onClick: handleClick,
    onSelect: handleClick,
    ...rest,
    ref: ref,
    children: children
  });
});

export { ButtonBase };
